import type {
    VueLocalization,
    LocaleKeys,
    NestedTranslations,
} from '@openticket/vue-localization';

function joinPath(base: string, path = ''): string {
    return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}

function xhrTranslations<T extends NestedTranslations = NestedTranslations>(
    url: string,
): Promise<T | undefined> {
    return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();

        xhr.open('GET', url);

        xhr.onload = function load() {
            if (this.status >= 200 && this.status < 300) {
                try {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    resolve(JSON.parse(xhr.response));

                    return;
                } catch (e) {
                    /* No-op */
                }
            }

            resolve(undefined);
        };

        xhr.onerror = function err() {
            resolve(undefined);
        };

        xhr.send();
    });
}

/**
 *  Get custom translations if applicable
 */
export async function initCustomTranslations(
    localization: VueLocalization,
    shopId: string,
    url?: string,
): Promise<void> {
    if (!url) {
        return;
    }

    try {
        const customTranslations:
            | { [locale in LocaleKeys]?: NestedTranslations }
            | undefined = await xhrTranslations<
            { [locale in LocaleKeys]?: NestedTranslations }
        >(joinPath(url, `/${shopId}/translations.json`));

        if (!customTranslations) {
            return;
        }

        for (const [ locale, nestedTranslations ] of Object.entries(
            customTranslations,
        )) {
            if (
                !locale
                || !nestedTranslations
                || !localization.isValidLocale(locale)
            ) {
                continue;
            }

            localization.addCustomMessages(locale, nestedTranslations);
        }
    } catch (e) {
        /* No-op */
    }
}
